(function (app) {

    app.run([
        "$rootScope", "$transitions", "userApi", function ($rootScope, $transitions, userApi) {
            $transitions.onSuccess({},
                function (trans) {
                    var to = trans.to();
                    var title = "", obj;
                    var model = {
                        DisplayName: '',
                        Route: to.name,
                        TransitionParams: new Object()
                    };

                    if (to.data && to.data.pageTitle) {
                        title = to.data.pageTitle;
                    }

                    if (to.name.startsWith("Home.Settings.Agency.User.")) {
                        obj = trans.injector().get("user");
                        title = obj.FirstName + " " + obj.LastName + " | " + title;
                    }
                    else if (to.name.startsWith("Home.Calendar")) {
                        title = "Calendar" + " | " + title;
                    }
                    else if (to.name.startsWith("Home.Client")) {
                        if (to.name.startsWith("Home.Client.Case") && !to.name.endsWith("Cases")) {
                            obj = trans.injector().get("clientCase");
                            title = obj.Name;
                            model.TransitionParams.caseId = obj.Id;
                        }

                        obj = trans.injector().get("client");
                        title = obj.Person.FirstName + " " + obj.Person.LastName + " | " + title;
                        model.TransitionParams.clientId = obj.Id;
                    }
                    else if (to.name.startsWith("Home.Marketing.Pipelines.Pipeline")) {
                        obj = trans.injector().get("pipeline");
                        title = obj.Name;
                    }
                    else if (to.name.startsWith("Home.Reports") && to.name !== "Home.Reports.List") {
                        obj = trans.injector().get("report");

                        if (obj && obj.Name) {
                            title = obj.Name + " | " + title;
                        }

                        if (to.name === "Home.Reports.Results") {
                            title = "Report Results" + " | " + title;
                        }
                        else if (to.name === "Home.Reports.New" || to.name === "Home.Reports.Edit") {
                            title = "Edit Report " + " | " + title;
                        }

                    }

                    model.DisplayName = title;

                    if (to.name.startsWith("Home.Client")) {
                        // TODO: need a better way to send back timestamp in local time
                        userApi.addUserHistoryEntry(model).finally(() => {
                            userApi.getCurrentUserHistory().then(response => {
                                response.forEach(x => x.TimeStamp += 'Z');
                                $rootScope.$broadcast('UserHistoryUpdated', response);
                            });
                        });
                    }
                });
        }
    ]);

})(window.app); //jshint ignore:line